/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3MetricsMemoryFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3MetricsMemoryFormat = ClosedEnum<
  typeof GetApiV3MetricsMemoryFormat
>;

export type GetApiV3MetricsMemoryRequest = {
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  /**
   * Subnet ID
   */
  subnet?: string | null | undefined;
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  format?: GetApiV3MetricsMemoryFormat | undefined;
  /**
   * Step value
   */
  step?: number | undefined;
};

/** @internal */
export const GetApiV3MetricsMemoryFormat$inboundSchema: z.ZodNativeEnum<
  typeof GetApiV3MetricsMemoryFormat
> = z.nativeEnum(GetApiV3MetricsMemoryFormat);

/** @internal */
export const GetApiV3MetricsMemoryFormat$outboundSchema: z.ZodNativeEnum<
  typeof GetApiV3MetricsMemoryFormat
> = GetApiV3MetricsMemoryFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsMemoryFormat$ {
  /** @deprecated use `GetApiV3MetricsMemoryFormat$inboundSchema` instead. */
  export const inboundSchema = GetApiV3MetricsMemoryFormat$inboundSchema;
  /** @deprecated use `GetApiV3MetricsMemoryFormat$outboundSchema` instead. */
  export const outboundSchema = GetApiV3MetricsMemoryFormat$outboundSchema;
}

/** @internal */
export const GetApiV3MetricsMemoryRequest$inboundSchema: z.ZodType<
  GetApiV3MetricsMemoryRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  start: z.nullable(z.number()).default(null),
  subnet: z.nullable(z.string()).default(null),
  end: z.nullable(z.number()).default(null),
  format: GetApiV3MetricsMemoryFormat$inboundSchema.default("json"),
  step: z.number().int().default(7200),
});

/** @internal */
export type GetApiV3MetricsMemoryRequest$Outbound = {
  start: number | null;
  subnet: string | null;
  end: number | null;
  format: string;
  step: number;
};

/** @internal */
export const GetApiV3MetricsMemoryRequest$outboundSchema: z.ZodType<
  GetApiV3MetricsMemoryRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3MetricsMemoryRequest
> = z.object({
  start: z.nullable(z.number()).default(null),
  subnet: z.nullable(z.string()).default(null),
  end: z.nullable(z.number()).default(null),
  format: GetApiV3MetricsMemoryFormat$outboundSchema.default("json"),
  step: z.number().int().default(7200),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsMemoryRequest$ {
  /** @deprecated use `GetApiV3MetricsMemoryRequest$inboundSchema` instead. */
  export const inboundSchema = GetApiV3MetricsMemoryRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsMemoryRequest$outboundSchema` instead. */
  export const outboundSchema = GetApiV3MetricsMemoryRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsMemoryRequest$Outbound` instead. */
  export type Outbound = GetApiV3MetricsMemoryRequest$Outbound;
}

export function getApiV3MetricsMemoryRequestToJSON(
  getApiV3MetricsMemoryRequest: GetApiV3MetricsMemoryRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsMemoryRequest$outboundSchema.parse(
      getApiV3MetricsMemoryRequest,
    ),
  );
}

export function getApiV3MetricsMemoryRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3MetricsMemoryRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetApiV3MetricsMemoryRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3MetricsMemoryRequest' from JSON`,
  );
}
